var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.17981 19.9883C9.27981 19.9883 10.1798 19.0883 10.1798 17.9883H6.17981C6.17981 19.0883 7.07981 19.9883 8.17981 19.9883ZM14.1798 13.9883V8.98828C14.1798 5.91828 12.5498 3.34828 9.67981 2.66828V1.98828C9.67981 1.15828 9.00981 0.488281 8.17981 0.488281C7.34981 0.488281 6.67981 1.15828 6.67981 1.98828V2.66828C3.81981 3.34828 2.17981 5.90828 2.17981 8.98828V13.9883L0.17981 15.9883V16.9883H16.1798V15.9883L14.1798 13.9883ZM12.1798 14.9883H4.17981V8.98828C4.17981 6.50828 5.68981 4.48828 8.17981 4.48828C10.6698 4.48828 12.1798 6.50828 12.1798 8.98828V14.9883Z",
    fill: "#CB8B65"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/NotificationIcon.e7db0235f2b3b3e7794b91bea415a880.svg";
export { ForwardRef as ReactComponent };